/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { useState } from 'react';
import { usePersistFn } from './usePersistFn.js';
import '../_chunks/dep-2acfafca.js';

var useSwitch = function useSwitch() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  return [state, {
    on: usePersistFn(function () {
      return setState(true);
    }),
    off: usePersistFn(function () {
      return setState(false);
    }),
    set: setState
  }];
};

export { useSwitch as default };
//# sourceMappingURL=useSwitch.js.map
